import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  textareaContainer: (hasError: boolean, margin?: string, width?: string) => ({
    position: 'relative',
    marginRight: margin ? `${margin}px` : 0,
    marginBottom: hasError ? 0 : '16px',
    width: `${width}%`,
    height: 'auto',
    transition: 'marginBottom .3s linear'
  }),
  textarea: (hasError: boolean, disabled: boolean) => ({
    width: '100%',
    minHeight: '64px',
    padding: '15px',
    borderRadius: 0,
    border: `1px solid ${hasError ? theme.rawColors.accent700 : theme.rawColors.lightGrey500}`,
    textAlign: 'start',
    background: 'neutralWhite',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.text,
    color: disabled ? theme.rawColors.lightGrey500 : theme.rawColors.darkGrey700,
    '&::placeholder': {
      color: theme.rawColors.darkGrey500
    },
    cursor: disabled ? 'not-allowed' : 'text'
  }),
  error: (hasError: boolean) => ({
    mt: hasError ? '4px' : 0,
    mb: '16px',
    marginLeft: '1rem',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.caption,
    color: theme.rawColors.accent700,
    height: hasError ? '16px' : 0,
    transition: 'padding .3s linear'
  }),
  label: (hasError: boolean, focused: boolean, disabled?: boolean) => ({
    position: 'absolute',
    left: '12px',
    top: focused ? '-8px' : '14px',
    padding: '0 4px',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: focused ? theme.fontSizes.caption : theme.fontSizes.text,
    zIndex: 2,
    color: !focused ? theme.rawColors.darkGrey500 : hasError ? theme.rawColors.accent700 : theme.rawColors.darkGrey500,
    letterSpacing: theme.letterSpacings.smallCaps,
    whiteSpace: 'nowrap',
    background: disabled ? theme.rawColors.lightGrey300 : theme.rawColors.neutralWhite,
    ...reusables.mainTransition('color, top, display'),
    pointerEvents: 'none'
  })
};